export default {"src":"/_next/static/image/public/images/ic_clock.7e3a2379b0189985de8b91f0d5fb8fd1.svg","height":16,"width":17};